import React, {FC} from 'react';

import {CustomIconProps} from './types';

const HowToIcon: FC<CustomIconProps> = ({size = 24, state = 'default'}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#faqHowToPaint0)">
        <path
          d="M27.0614 26.5588C26.47 27.1825 25.9104 27.5846 25.4683 27.9024C20.2715 31.6378 14.1224 30.549 12.8154 30.2831C10.8856 29.8904 7.15523 29.1314 4.45821 25.9542C0.377905 21.1473 1.01325 13.5743 4.17825 8.57516C4.75729 7.66074 7.81522 2.58544 14.0307 1.77159C17.7922 1.27901 22.1769 2.27243 25.3523 4.9375C32.0174 10.5314 31.5429 21.8323 27.0614 26.5588Z"
          fill="url(#faqHowToPaint0_linear)"
        />
        <path
          d="M14.6954 12.4358C14.6954 11.7741 15.2335 11.2375 15.8972 11.2375H26.1175C26.6814 11.2375 27.1463 11.6781 27.175 12.2396L27.9294 27.0134C27.9519 27.4527 27.605 27.8233 27.1638 27.8313L15.45 28.0435C15.0355 28.051 14.6953 27.7181 14.6953 27.3047V12.4358H14.6954Z"
          fill="url(#faqHowToPaint1_linear)"
        />
        <path
          d="M17.1625 27.7924C17.1625 27.7924 17.1623 27.7924 17.1622 27.7924L15.8515 27.7755C15.4132 27.7698 15.0566 27.4097 15.0566 26.9727V24.9996C15.0566 24.9843 15.0692 24.9717 15.0846 24.9717C15.1001 24.9717 15.1126 24.9842 15.1126 24.9996V26.9727C15.1126 27.3794 15.4444 27.7144 15.8522 27.7197L17.1629 27.7366C17.1783 27.7368 17.1907 27.7495 17.1905 27.7649C17.1903 27.7802 17.1778 27.7924 17.1625 27.7924Z"
          fill="#91B3FA"
        />
        <path
          d="M15.0846 24.4164C15.0692 24.4164 15.0566 24.4039 15.0566 24.3884V24.0689C15.0566 24.0535 15.0692 24.041 15.0846 24.041C15.1001 24.041 15.1126 24.0534 15.1126 24.0689V24.3884C15.1126 24.4039 15.1001 24.4164 15.0846 24.4164Z"
          fill="#91B3FA"
        />
        <path
          d="M15.5322 11.465C15.531 11.2532 15.7178 11.0894 15.9281 11.1178C17.3238 11.3065 22.1232 11.8901 26.0913 11.5864C26.2723 11.5726 26.4292 11.7093 26.4389 11.89L27.23 26.7296C27.2409 26.933 27.085 27.107 26.881 27.1191C25.2121 27.2175 18.3391 27.5982 15.8876 27.3422C15.7384 27.3266 15.6251 27.2013 15.6243 27.0518L15.5322 11.465Z"
          fill="url(#faqHowToPaint2_linear)"
        />
        <path
          d="M15.6963 11.8369C15.6951 11.6332 15.8748 11.4755 16.0773 11.5028C17.4205 11.6844 22.0391 12.2461 25.8577 11.9538C26.0319 11.9404 26.183 12.072 26.1923 12.2459L26.9535 26.5268C26.964 26.7226 26.814 26.89 26.6177 26.9016C25.0116 26.9963 18.3974 27.3627 16.0382 27.1163C15.8946 27.1013 15.7856 26.9807 15.7848 26.8368L15.6963 11.8369Z"
          fill="#91B3FA"
        />
        <path
          d="M21.2024 12.8229L21.3588 15.8846C21.364 15.9864 21.4545 16.0674 21.5666 16.0703C22.1903 16.0863 24.1338 16.1294 25.2312 16.0773C25.3553 16.0715 25.4536 15.9802 25.4576 15.8672C25.4785 15.293 25.5243 13.6219 25.3804 12.9232C25.3572 12.8104 25.2505 12.7277 25.1242 12.7237L21.4377 12.6065C21.3048 12.6023 21.1962 12.7022 21.2024 12.8229Z"
          fill="url(#faqHowToPaint3_linear)"
        />
        <g opacity="0.6">
          <path
            opacity="0.6"
            d="M20.7166 13.2044C20.7746 13.2044 20.8208 13.1582 20.8191 13.1017C20.8174 13.0452 20.7686 12.9981 20.7105 12.9971L16.9961 12.9311C16.938 12.9301 16.9063 12.9739 16.9256 13.0285L16.9527 13.1051C16.9719 13.1597 17.0352 13.2044 17.0933 13.2044H20.7166Z"
            fill="white"
          />
        </g>
        <g opacity="0.6">
          <path
            opacity="0.6"
            d="M20.7781 15.6295C20.8362 15.6295 20.8823 15.5832 20.8806 15.5267C20.879 15.4702 20.8301 15.4231 20.772 15.4222L17.0576 15.3561C16.9995 15.3551 16.9678 15.3989 16.9871 15.4536L17.0142 15.5301C17.0335 15.5848 17.0967 15.6295 17.1548 15.6295H20.7781Z"
            fill="white"
          />
        </g>
        <g opacity="0.6">
          <path
            opacity="0.6"
            d="M16.9961 13.5019C16.938 13.5009 16.9063 13.5447 16.9256 13.5993L16.9527 13.6759C16.9719 13.7305 17.0352 13.7752 17.0933 13.7752H20.7165C20.7746 13.7752 20.8207 13.729 20.819 13.6725C20.8174 13.616 20.7685 13.5689 20.7105 13.5679L16.9961 13.5019Z"
            fill="white"
          />
        </g>
        <g opacity="0.6">
          <path
            opacity="0.6"
            d="M16.9961 14.081C16.938 14.0799 16.9063 14.1238 16.9256 14.1784L16.9527 14.255C16.9719 14.3096 17.0352 14.3543 17.0933 14.3543H20.7165C20.7746 14.3543 20.8207 14.3081 20.819 14.2516C20.8174 14.1951 20.7685 14.148 20.7105 14.147L16.9961 14.081Z"
            fill="white"
          />
        </g>
        <g opacity="0.6">
          <path
            opacity="0.6"
            d="M17.0332 14.6926C16.9751 14.6915 16.9434 14.7354 16.9627 14.79L16.9898 14.8666C17.0091 14.9212 17.0723 14.9659 17.1304 14.9659H20.7536C20.8117 14.9659 20.8578 14.9197 20.8562 14.8631C20.8545 14.8066 20.8057 14.7596 20.7476 14.7586L17.0332 14.6926Z"
            fill="white"
          />
        </g>
        <g opacity="0.6">
          <path
            opacity="0.6"
            d="M25.7223 16.9991C25.7804 16.9991 25.8248 16.9529 25.8211 16.8964C25.8173 16.8398 25.7668 16.7933 25.7087 16.7928L17.0448 16.7248C16.9867 16.7243 16.9689 16.761 17.0051 16.8063L17.0933 16.9168C17.1295 16.9621 17.2066 16.9991 17.2646 16.9991H25.7223Z"
            fill="white"
          />
        </g>
        <g opacity="0.6">
          <path
            opacity="0.6"
            d="M17.0448 18.0342C16.9867 18.0337 16.9689 18.0704 17.0051 18.1157L17.0933 18.2262C17.1295 18.2715 17.2066 18.3085 17.2646 18.3085H25.7223C25.7804 18.3085 25.8248 18.2623 25.8211 18.2058C25.8173 18.1493 25.7668 18.1027 25.7087 18.1023L17.0448 18.0342Z"
            fill="white"
          />
        </g>
        <g opacity="0.6">
          <path
            opacity="0.6"
            d="M16.9872 19.3761C16.9291 19.3756 16.9112 19.4123 16.9474 19.4577L17.0357 19.5682C17.0719 19.6135 17.149 19.6505 17.207 19.6505H25.6647C25.7228 19.6505 25.7672 19.6043 25.7634 19.5477C25.7597 19.4912 25.7092 19.4446 25.6511 19.4442L16.9872 19.3761Z"
            fill="white"
          />
        </g>
        <g opacity="0.6">
          <path
            opacity="0.6"
            d="M16.7502 20.952C16.7777 21.0316 16.8714 21.0865 16.9777 21.0854L25.6449 20.9876C25.7429 20.9865 25.8211 20.9234 25.8186 20.8474C25.8161 20.7735 25.7382 20.7147 25.6429 20.7148L16.9751 20.7245C16.8221 20.7246 16.7107 20.8373 16.7502 20.952Z"
            fill="white"
          />
        </g>
        <g opacity="0.6">
          <path
            opacity="0.6"
            d="M16.758 22.5094C16.7855 22.589 16.8792 22.644 16.9855 22.6428L25.6527 22.5451C25.7508 22.5439 25.8289 22.4808 25.8264 22.4048C25.8239 22.3309 25.7461 22.2721 25.6507 22.2722L16.9829 22.2819C16.8299 22.282 16.7185 22.3948 16.758 22.5094Z"
            fill="white"
          />
        </g>
        <g opacity="0.6">
          <path
            opacity="0.6"
            d="M16.7649 24.0668C16.7924 24.1465 16.886 24.2014 16.9924 24.2002L25.6595 24.1025C25.7576 24.1014 25.8357 24.0383 25.8332 23.9623C25.8308 23.8883 25.7529 23.8295 25.6576 23.8297L16.9898 23.8394C16.8368 23.8395 16.7253 23.9523 16.7649 24.0668Z"
            fill="white"
          />
        </g>
        <g opacity="0.6">
          <path
            opacity="0.6"
            d="M16.7717 25.6242C16.7992 25.7039 16.8929 25.7588 16.9992 25.7576L25.6664 25.6599C25.7644 25.6587 25.8426 25.5957 25.84 25.5196C25.8376 25.4457 25.7597 25.3869 25.6644 25.387L16.9966 25.3967C16.8436 25.3969 16.7321 25.5096 16.7717 25.6242Z"
            fill="white"
          />
        </g>
        <path
          d="M21.6415 9.2232C21.2723 8.96714 20.9513 8.97218 20.7254 9.03869C20.5192 9.09933 20.3856 9.29775 20.4052 9.51114L20.5027 10.5716L21.6623 10.6742C21.6623 10.6743 22.3655 9.72537 21.6415 9.2232ZM21.1316 10.0788C20.9719 10.0788 20.8424 9.94974 20.8424 9.79048C20.8424 9.63123 20.9719 9.50219 21.1316 9.50219C21.2913 9.50219 21.4207 9.63123 21.4207 9.79048C21.4207 9.94974 21.2913 10.0788 21.1316 10.0788Z"
          fill="url(#faqHowToPaint4_linear)"
        />
        <path
          d="M20.6178 10.1255C20.6035 10.1255 20.5913 10.1147 20.5899 10.1002L20.5744 9.93124C20.573 9.91593 20.5843 9.90236 20.5997 9.90089C20.6155 9.89942 20.6288 9.91075 20.6302 9.92614L20.6457 10.095C20.6471 10.1104 20.6358 10.1239 20.6204 10.1254C20.6195 10.1255 20.6186 10.1255 20.6178 10.1255ZM20.5873 9.79458C20.573 9.79458 20.5608 9.78374 20.5595 9.76919L20.5477 9.64099C20.529 9.43775 20.6573 9.24842 20.8527 9.19093C20.9911 9.15022 21.1337 9.14435 21.2765 9.17358C21.2917 9.17666 21.3014 9.19142 21.2983 9.20652C21.2953 9.22156 21.2806 9.23121 21.2653 9.2282C21.1315 9.20093 20.998 9.20631 20.8686 9.24443C20.6987 9.29444 20.5872 9.45908 20.6034 9.63589L20.6152 9.76409C20.6166 9.7794 20.6053 9.79297 20.5899 9.79444C20.5891 9.79451 20.5882 9.79458 20.5873 9.79458Z"
          fill="#91B3FA"
        />
        <path
          d="M18.9199 11.2571V10.7238C18.9199 10.5398 19.0729 10.3924 19.2574 10.3987L22.9445 10.5247C23.1082 10.5303 23.2407 10.659 23.2504 10.822L23.2812 11.3343L18.9199 11.2571Z"
          fill="url(#faqHowToPaint5_linear)"
        />
        <path
          d="M20.2946 10.5998H20.1355C20.12 10.5998 20.1074 10.5873 20.1074 10.5718C20.1074 10.5563 20.12 10.5438 20.1355 10.5438H20.2946C20.3101 10.5438 20.3227 10.5563 20.3227 10.5718C20.3227 10.5873 20.3101 10.5998 20.2946 10.5998Z"
          fill="#91B3FA"
        />
        <path
          d="M19.1198 11.0896C19.1044 11.0896 19.0918 11.0771 19.0918 11.0617V10.846C19.0918 10.6793 19.2278 10.5438 19.395 10.5438H19.9779C19.9933 10.5438 20.0059 10.5562 20.0059 10.5717C20.0059 10.5871 19.9933 10.5996 19.9779 10.5996H19.395C19.2587 10.5996 19.1478 10.7102 19.1478 10.846V11.0617C19.1478 11.0771 19.1352 11.0896 19.1198 11.0896Z"
          fill="#91B3FA"
        />
        <path
          d="M17.4169 11.3917C17.4258 11.2071 17.5785 11.062 17.7639 11.062L24.2115 11.0618C24.4433 11.0618 24.6415 11.2281 24.681 11.4559L24.6865 11.4873C24.7298 11.7368 24.5372 11.9649 24.2832 11.9649H17.6684C17.5165 11.9649 17.3954 11.8382 17.4027 11.6869L17.4169 11.3917Z"
          fill="url(#faqHowToPaint6_linear)"
        />
        <path
          d="M9.45742 4.38293L9.45742 4.38293C10.5073 3.94655 11.679 3.76512 12.8246 3.77415L9.45742 4.38293ZM9.45742 4.38293C8.23065 4.89284 7.09894 5.81931 6.37037 6.97095C5.63865 8.12755 5.29978 9.53788 5.72589 10.9791L5.72589 10.9791M9.45742 4.38293L5.72589 10.9791M5.72589 10.9791C5.7777 11.1543 5.81144 11.34 5.84683 11.5485M5.72589 10.9791L5.84683 11.5485M12.2556 7.3193L12.2556 7.3193C11.9097 7.3088 11.4675 7.36042 11.0828 7.4976C10.6892 7.63802 10.4371 7.83704 10.333 8.06355L12.2556 7.3193ZM12.2556 7.3193C13.0357 7.34293 13.7308 7.72667 14.1438 8.37909L14.1438 8.37912M12.2556 7.3193L14.1438 8.37912M14.1438 8.37912C14.6962 9.25162 14.8522 10.3416 14.7652 11.4318C14.6775 12.5299 14.2209 13.3793 13.4791 14.2815L13.4791 14.2815M14.1438 8.37912L13.4791 14.2815M13.4791 14.2815C13.3681 14.4164 13.2523 14.5536 13.1341 14.6936C12.5707 15.3608 11.9533 16.092 11.5558 16.9461L12.0091 17.157C12.3756 16.3695 12.9399 15.7002 13.5019 15.0337C13.6238 14.8891 13.7456 14.7446 13.8653 14.5991C14.6448 13.6511 15.1649 12.7074 15.2636 11.4716C15.3557 10.3168 15.1962 9.10661 14.5663 8.11166C14.0609 7.31329 13.2099 6.84798 12.2708 6.81953L13.4791 14.2815ZM10.0215 22.4601L10.0215 22.4598C10.0198 22.2262 10.1086 21.9381 10.1928 21.7008C10.2852 21.4403 10.4064 21.1513 10.5234 20.8836C10.5822 20.7489 10.6409 20.6174 10.6953 20.4958L10.7097 20.4635C10.7588 20.3537 10.8036 20.2536 10.8425 20.1648C10.8856 20.0663 10.9181 19.9891 10.9394 19.9336C10.9431 19.924 10.9461 19.9158 10.9486 19.909C10.9718 18.9281 11.1135 17.8964 11.5558 16.9461L10.0215 22.4601ZM10.0215 22.4601C10.0227 22.6074 10.086 22.7118 10.1232 22.7619C10.1622 22.8143 10.2031 22.8489 10.2268 22.8672C10.2745 22.9042 10.3213 22.9284 10.3473 22.9411C10.4044 22.9691 10.469 22.993 10.5246 23.0121C10.6409 23.0521 10.7879 23.0942 10.9277 23.1315C11.0696 23.1693 11.2138 23.2046 11.3287 23.2308C11.3858 23.2438 11.4382 23.2551 11.4806 23.2635L11.4848 23.2644C11.5084 23.2691 11.58 23.2835 11.642 23.2842L11.6421 23.2842M10.0215 22.4601L11.6421 23.2842M11.6421 23.2842L13.569 23.3058M11.6421 23.2842L16.9198 16.1727M16.9198 16.1727L16.9198 16.1727C15.0287 17.8068 14.2583 20.142 14.23 22.6596C14.226 23.0221 13.9284 23.3098 13.569 23.3058M16.9198 16.1727C17.0973 16.0194 17.2793 15.8722 17.4673 15.7206L17.4948 15.6984C17.6723 15.5554 17.8554 15.4079 18.0343 15.2548C18.4119 14.9319 18.7888 14.5701 19.1097 14.1199L19.1097 14.1199M16.9198 16.1727L19.1097 14.1199M13.569 23.3058L13.5746 22.8058L13.569 23.3058H13.569ZM19.1097 14.1199C19.9825 12.8958 20.4357 11.6502 20.3075 10.0913L20.3075 10.0913M19.1097 14.1199L20.3075 10.0913M20.3075 10.0913C20.1947 8.72075 19.7424 7.31855 18.8176 6.21572L18.8175 6.2157M20.3075 10.0913L18.8175 6.2157M18.8175 6.2157C17.8243 5.03133 16.3893 4.31099 14.9291 4.00255L14.929 4.00253M18.8175 6.2157L14.929 4.00253M14.929 4.00253C14.2548 3.86019 13.5421 3.77977 12.8247 3.77415L14.929 4.00253ZM5.84683 11.5485C5.84983 11.5663 5.85286 11.5842 5.85592 11.6024M5.84683 11.5485L5.85592 11.6024M5.85592 11.6024C5.8872 11.788 5.92245 11.997 5.97557 12.1945M5.85592 11.6024L5.97557 12.1945M5.97557 12.1945C6.09848 12.6514 6.34126 13.1346 6.94559 13.3987M5.97557 12.1945L6.94559 13.3987M6.94559 13.3987C7.24711 13.5304 7.73029 13.6129 8.16004 13.6482M6.94559 13.3987L8.16004 13.6482M8.16004 13.6482C8.38438 13.6665 8.61439 13.6737 8.82481 13.665M8.16004 13.6482L8.82481 13.665M8.82481 13.665C9.02672 13.6566 9.24409 13.6326 9.42566 13.5722M8.82481 13.665L9.42566 13.5722M9.42566 13.5722C10.1299 13.338 10.7524 12.8884 11.0977 12.2715M9.42566 13.5722L11.0977 12.2715M11.0977 12.2715C11.4547 11.6339 11.4874 10.8633 11.0744 10.0966L11.0977 12.2715ZM11.0743 10.0966C10.9787 9.91908 10.8705 9.74612 10.7726 9.58966C10.7513 9.55572 10.7306 9.52255 10.7105 9.49028C10.5932 9.30121 10.4931 9.13177 10.4154 8.95876C10.2583 8.6087 10.2313 8.28509 10.333 8.06359L11.0743 10.0966Z"
          fill="#2F3D89"
          stroke="#E5EBFD"
        />
        <path
          d="M11.4318 28.3893L11.4318 28.3893C11.5555 28.434 11.7116 28.4533 11.8288 28.4646C11.9624 28.4775 12.1136 28.4855 12.2591 28.4905C12.5352 28.5002 12.8132 28.5001 12.9508 28.5001C12.9586 28.5001 12.9659 28.5001 12.9727 28.5001C13.7385 28.5001 14.3482 28.1533 14.7528 27.6209C15.148 27.1009 15.3372 26.422 15.3372 25.7353C15.3372 24.9464 14.919 24.2913 14.3632 23.8494C13.8096 23.4092 13.0831 23.1474 12.3673 23.1474C11.5635 23.1474 11.0072 23.5617 10.6796 24.143C10.3691 24.6939 10.2627 25.3872 10.2627 26.0309C10.2627 26.0452 10.2627 26.0596 10.2627 26.0741C10.2625 26.5062 10.2624 26.976 10.3943 27.3726C10.5511 27.844 10.8798 28.1895 11.4318 28.3893Z"
          fill="#2F3D89"
          stroke="#E5EBFD"
        />
        <path
          d="M11.7817 4.00031C10.6885 3.99168 9.58581 4.16532 8.61027 4.5708C6.33937 5.51471 4.41204 8.01233 5.16631 10.5635C5.41133 11.3922 5.97781 12.4354 6.80196 12.7956C7.24786 12.9904 7.767 12.9775 8.22874 12.8239C9.45594 12.4158 10.2625 11.2987 9.5951 10.0599C9.3814 9.66322 9.10471 9.30076 8.92018 8.88968C8.73566 8.47851 8.65149 7.99052 8.83963 7.58099C9.20902 6.7771 10.436 6.52155 11.2317 6.54569C12.1708 6.57414 13.0218 7.03946 13.5272 7.83783C14.1571 8.83277 14.3167 10.0429 14.2245 11.1978C14.1259 12.4335 13.6057 13.3773 12.8262 14.3252C12.1551 15.1415 11.4161 15.9248 10.9701 16.8832C10.5606 17.7631 10.4267 18.7379 10.4082 19.7004C10.4046 19.887 10.4674 21.8352 10.4713 22.3723C10.4719 22.4482 10.5329 22.5095 10.6086 22.5103C11.0039 22.5147 12.1234 22.5273 12.5355 22.5319C12.6203 22.5328 12.6901 22.465 12.691 22.3801C12.7204 19.7669 13.5227 17.2755 15.5539 15.5205C16.2929 14.8819 17.0888 14.3618 17.6636 13.5557C18.4826 12.4069 18.8867 11.2763 18.7701 9.85841C18.6636 8.56343 18.238 7.26785 17.3954 6.26307C16.4897 5.1832 15.1643 4.50881 13.7867 4.21783C13.1443 4.0823 12.4648 4.00565 11.7817 4.00031Z"
          fill="#556CD6"
        />
        <path
          d="M11.8946 27.9328C13.0941 27.9328 14.0665 26.9587 14.0665 25.757C14.0665 24.5554 13.0941 23.5813 11.8946 23.5813C10.6951 23.5813 9.72266 24.5554 9.72266 25.757C9.72266 26.9587 10.6951 27.9328 11.8946 27.9328Z"
          fill="#556CD6"
        />
        <path
          opacity="0.63"
          d="M5.88558 10.3137C5.87275 10.3137 5.86122 10.3048 5.85838 10.2918C5.70613 9.60337 5.68384 8.52522 6.44173 7.2987C7.18145 6.10166 8.21913 5.30062 9.52585 4.91799C10.9228 4.50897 12.5811 4.59657 14.4553 5.17828C14.47 5.18285 14.4783 5.19845 14.4737 5.21319C14.4691 5.22794 14.4534 5.23621 14.4388 5.23165C10.8384 4.11401 8.01516 4.85858 6.48915 7.32819C5.74107 8.53867 5.76285 9.60147 5.91286 10.2798C5.91622 10.2949 5.90666 10.3097 5.89169 10.3131C5.88962 10.3135 5.88756 10.3137 5.88558 10.3137Z"
          fill="white"
        />
        <path
          opacity="0.63"
          d="M6.3419 11.4214C6.33329 11.4214 6.32486 11.4175 6.31935 11.41C6.31272 11.4009 6.15626 11.1842 6.01064 10.8027C6.00513 10.7883 6.01236 10.7722 6.02673 10.7667C6.04102 10.7612 6.0572 10.7683 6.06271 10.7828C6.2054 11.1568 6.36273 11.3749 6.36428 11.377C6.37331 11.3894 6.37064 11.4069 6.35817 11.416C6.35335 11.4197 6.34758 11.4214 6.3419 11.4214Z"
          fill="white"
        />
        <path
          opacity="0.63"
          d="M12.6218 24.3467C12.6176 24.3467 12.6133 24.3458 12.6092 24.3437C12.3867 24.2306 12.1464 24.1733 11.8951 24.1733C11.8797 24.1733 11.8672 24.1608 11.8672 24.1453C11.8672 24.1299 11.8797 24.1174 11.8951 24.1174C12.1552 24.1174 12.4041 24.1768 12.6345 24.2939C12.6481 24.3009 12.6536 24.3177 12.6467 24.3314C12.6418 24.3411 12.632 24.3467 12.6218 24.3467Z"
          fill="white"
        />
        <path
          opacity="0.63"
          d="M10.9959 27.1213C10.9906 27.1213 10.9852 27.1197 10.9804 27.1164C10.5285 26.8106 10.2588 26.3025 10.2588 25.757C10.2588 25.1522 10.5894 24.5985 11.1216 24.3119C11.1351 24.3046 11.1521 24.3096 11.1594 24.3233C11.1667 24.3369 11.1616 24.3538 11.148 24.3611C10.6339 24.638 10.3145 25.1728 10.3145 25.757C10.3145 26.2838 10.5751 26.7748 11.0115 27.0702C11.0242 27.0788 11.0276 27.0962 11.019 27.109C11.0137 27.1169 11.0049 27.1213 10.9959 27.1213Z"
          fill="white"
        />
        {state === 'default' && (
          <g style={{mixBlendMode: 'saturation'}}>
            <rect width="32" height="32" fill="white" />
          </g>
        )}
      </g>
      <defs>
        <linearGradient
          id="faqHowToPaint0_linear"
          x1="34.1444"
          y1="39.1911"
          x2="8.34263"
          y2="7.20353"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DAE3FE" />
          <stop offset="1" stopColor="#E9EFFD" />
        </linearGradient>
        <linearGradient
          id="faqHowToPaint1_linear"
          x1="21.3085"
          y1="27.0512"
          x2="20.3741"
          y2="-0.690766"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#09005D" />
          <stop offset="1" stopColor="#1A0F91" />
        </linearGradient>
        <linearGradient
          id="faqHowToPaint2_linear"
          x1="13.3392"
          y1="30.9394"
          x2="25.2106"
          y2="13.3729"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F52FF" />
          <stop offset="1" stopColor="#4042E2" />
        </linearGradient>
        <linearGradient
          id="faqHowToPaint3_linear"
          x1="25.4815"
          y1="14.3543"
          x2="21.2022"
          y2="14.3543"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DAE3FE" />
          <stop offset="1" stopColor="#E9EFFD" />
        </linearGradient>
        <linearGradient
          id="faqHowToPaint4_linear"
          x1="22.7818"
          y1="7.70216"
          x2="18.0984"
          y2="13.8813"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#09005D" />
          <stop offset="1" stopColor="#1A0F91" />
        </linearGradient>
        <linearGradient
          id="faqHowToPaint5_linear"
          x1="23.2973"
          y1="8.09299"
          x2="18.6139"
          y2="14.2721"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#09005D" />
          <stop offset="1" stopColor="#1A0F91" />
        </linearGradient>
        <linearGradient
          id="faqHowToPaint6_linear"
          x1="22.7042"
          y1="8.47019"
          x2="19.4731"
          y2="14.4208"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F52FF" />
          <stop offset="1" stopColor="#4042E2" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default HowToIcon;
